import i18n from "i18next";

import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import languageEN from "../locate/en/translate.json";
import languageDE from "../locate/de/translate.json";
//import XHR from 'i18next-xhr-backend'
//.use(XHR)

// the translations

const initLanguage = () => {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        en: languageEN,
        de: languageDE,
      },
      /* default language when load the website in browser */
      // lng: "de",
      /* When react i18next not finding any language to as default in borwser */
      fallbackLng: "en",
      /* only these are shipped; map region variants (de-AT, de-DE, en-US, ...)
         onto the base language so an Austrian/German browser resolves to "de"
         instead of falling back to English */
      supportedLngs: ["en", "de"],
      load: "languageOnly",
      nonExplicitSupportedLngs: true,
      /* debugger For Development environment */
      debug: process.env.NODE_ENV === "development",
      ns: ["translations"],
      defaultNS: "translations",
      keySeparator: ".",
      interpolation: {
        escapeValue: false,
        formatSeparator: ",",
      } /*
      react: {
        wait: true,
        bindI18n: "languageChanged loaded",
        bindStore: "added removed",
        nsMode: "default",
      },*/,
      detection: {
        // Saved user choice first, then the browser/OS language; anything
        // unsupported (e.g. fr) is governed by fallbackLng ("en").
        // htmlTag/path/subdomain are intentionally omitted: <html lang="de">
        // would otherwise make every unsupported browser default to German.
        order: ["cookie", "localStorage", "sessionStorage", "navigator"],

        // keys or params to lookup language from
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupSessionStorage: "i18nextLng",
        lookupFromPathIndex: 0,
        lookupFromSubdomainIndex: 0,

        // cache user language on
        caches: ["localStorage", "cookie"],
        excludeCacheFor: ["cimode"], // languages to not persist (cookie, localStorage)
      },
    });

  return i18n;
};

const changeLanguage = (language) => {
  return i18n.changeLanguage(language);
};

const getLanguage = () => {
  return i18n.language;
};

const getSupportedLanguages = () => {
  return i18n.languages;
};

const LanguageService = {
  initLanguage,
  changeLanguage,
  getLanguage,
  getSupportedLanguages,
};

export default LanguageService;
